export type Size = '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'xxs';

export const SIZE_MAP = {
  xxs: '12px',
  xs: '16px',
  sm: '20px',
  md: '24px',
  lg: '30px',
  xl: '40px',
  '2xl': '56px',
};
